import compileSymbols from '~/utils/compileSymbols';

var types = ['UPDATE_NOTES'];

export default compileSymbols(types, 'notes');
